import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    APIS,
    SF_COMN_CD_MGMT_MSTR_SRCH,
    SG_COMN_CD_MGMT_MSTR_LIST,
    URLS,
} from "./services/PtliComnCdAppService";

/*
 * Common Code Management List
 * !== 공통 코드 관리 목록 페이지... ==!
 */
export const PTLI0404001Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0061", "auth_ecti0001", "auth_ecti0009"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const searchParams = new URLSearchParams(window.location.search); //MENU_PRMT_VALUE
    const bsopClsfCd = searchParams.get("bsopClsfCd");

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "COM0024" }],
    });

    const form = {
        comnCdMgmtMstrSrch: useForm({
            defaultSchema: SF_COMN_CD_MGMT_MSTR_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const grid = {
        comnCdMgmtMstrList: useGrid({
            defaultSchema: SG_COMN_CD_MGMT_MSTR_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Check Common Code List !== 공통 코드 목록 조회 ==!
        getComnCdMstrList: useFetch({
            api: (page = grid.comnCdMgmtMstrList.page) =>
                APIS.getComnCdMstrList(form.comnCdMgmtMstrSrch.getValues(), page, grid.comnCdMgmtMstrList.size),
            enabled: comnUtils.isEmpty(form.comnCdMgmtMstrSrch.errors) && form.comnCdMgmtMstrSrch.isSubmitted,
            key: [grid.comnCdMgmtMstrList.page, grid.comnCdMgmtMstrList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.comnCdMgmtMstrSrch.getValues(),
                    page: grid.comnCdMgmtMstrList.page,
                    size: grid.comnCdMgmtMstrList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Delete Common Code !== 공통 코드 삭제 ==!
        deleteComnCdMstr: useFetch({
            api: (comnCds: any) => APIS.deleteComnCdMstr(comnCds),
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00060" }); // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                handler.getComnCdMstrList();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00023" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            comnCd: (props: any) => {
                const { rowValues, value } = props;
                if (bsopClsfCd) {
                    return (
                        <Link to={`${URLS.ptli0404003q}/${rowValues.comnCd}?bsopClsfCd=${bsopClsfCd}`}>{value}</Link>
                    );
                } else {
                    return <Link to={`${URLS.ptli0404003q}/${rowValues.comnCd}`}>{value}</Link>;
                }
            },
        },
    };

    const handler = {
        // Check Common Code List !== 공통 코드 목록 조회 ==!
        getComnCdMstrList: () => {
            form.comnCdMgmtMstrSrch.handleSubmit(
                () => {
                    grid.comnCdMgmtMstrList.setPage(0);
                    fetch.getComnCdMstrList.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        // Delete Common Code !== 공통 코드 삭제 ==!
        deleteComnCdMstr: () => {
            const list: any[] = grid.comnCdMgmtMstrList.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    const comnCds: string[] = [];
                    list.forEach((item) => {
                        comnCds.push(`${item.comnCd}`);
                    });
                    fetch.deleteComnCdMstr.fetch(comnCds.join(","));
                },
            });
        },
    };

    useEffect(() => {
        if (bsopClsfCd) {
            form.comnCdMgmtMstrSrch.setValue("bsopClsfCd", bsopClsfCd);
        }
        handler.getComnCdMstrList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row hidden={bsopClsfCd != undefined && bsopClsfCd != ""}>
                            <Group.Control {...form.comnCdMgmtMstrSrch.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrSrch.schema.comnCd} />
                            <Group.Control {...form.comnCdMgmtMstrSrch.schema.comnCdNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button
                                role={"reset"}
                                onClick={() => {
                                    form.comnCdMgmtMstrSrch.reset();
                                    if (bsopClsfCd) {
                                        form.comnCdMgmtMstrSrch.setValue("bsopClsfCd", bsopClsfCd);
                                    }
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getComnCdMstrList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Right>
                            <Button role={"delete"} onClick={handler.deleteComnCdMstr}></Button>
                        </Layout.Right>
                    </Layout>
                    <Group.Section>
                        <Grid
                            {...grid.comnCdMgmtMstrList.grid}
                            data={fetch.getComnCdMstrList.data?.comnCdMstrList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role={"new"}
                    onClick={() => {
                        if (bsopClsfCd) {
                            navigate(`${URLS.ptli0404002s}?bsopClsfCd=${bsopClsfCd}`);
                        } else {
                            navigate(`${URLS.ptli0404002s}`);
                        }
                    }}
                />
            </Layout.Left>
        </Page>
    );
};
